import { Box, Container, Header, Link } from '@amzn/awsui-components-react';
import React, { useState } from 'react';
import { OpenCalculationReviewsResult } from 'src/models/dashboard/OpenCalculationReview';
import OpenCalculationReviewsGrid from './OpenCalculationReviewsGrid';
import CONSTANTS from 'src/utils/constants';
import TPENavigator from '../TPENavigator';

export default function OpenCalculationReviewsContainer(props: {openCalculationReviewsResult: OpenCalculationReviewsResult, openCalculationReviewsLoading: boolean}) {
    const { openCalculationReviewsResult, openCalculationReviewsLoading } = props;
    const [ navigateURL, setNavigateURL] = useState('');

    return <Container
      header={
          <Header
          counter={openCalculationReviewsLoading ? '(...)' : `(${openCalculationReviewsResult ? openCalculationReviewsResult.totalSize : '0'})`}
          description="CLIs assigned to me that have status change from last MEC in ATP"
          >
          Open CLI review
          </Header>
      }
      footer={
        <Box textAlign="center">
          <Link 
            href="javascript:void(0)"
            variant="primary"
            onFollow={(event: any) => setNavigateURL(CONSTANTS.PAGE_NAV.CALCULATION_REVIEWS.URL)}
          >
            View all CLI reviews</Link>
        </Box>
      }
    >
      <TPENavigator path={navigateURL}/>
      <OpenCalculationReviewsGrid openCalculationReviewsResult={openCalculationReviewsResult} isLoading={openCalculationReviewsLoading} dashboardView={true}/>
    </Container>
}